export class StateTable {
    constructor(tableEl, ctrl) {
        this.table = tableEl;
        this.ctrl = ctrl;
        this.tbody = tableEl.querySelector('tbody');
        this.template = tableEl.querySelector('template[data-row-template]');
        this.stateKey = tableEl.getAttribute('data-bind');
        this.stateOwner = tableEl.getAttribute('data-source');
        // Рендереры колонок из компонента
        this.columnRenderers = ctrl.columns || {};
    }

    render() {
        function getByPath(obj, path) {
            const keys = path.match(/[^.[\]]+/g);
            return keys.reduce((acc, key) => acc?.[key], obj);
        }

        const ctrl = ajaxUtils.state.ctrl[this.stateOwner];
        const data = getByPath(ctrl.state, this.stateKey);
        if (!Array.isArray(data))
            return;

        // Сохраняем скролл
        const scrollTop = this.tbody.parentElement.scrollTop;

        // Очищаем
        while (this.tbody.firstChild && this.tbody.firstChild !== this.template) {
            if (this.tbody.firstChild.tagName === 'TR') {
                this.tbody.removeChild(this.tbody.firstChild);
            } else {
                break;
            }
        }
        // Проще:
        this.tbody.querySelectorAll('tr').forEach(r => r.remove());

        const fragment = document.createDocumentFragment();

        for (let i = 0; i < data.length; i++) {
            const item = data[i];
            const row = this.template.content.cloneNode(true).firstElementChild;

            this.populateRow(row, item, i);
            fragment.appendChild(row);
        }

        this.tbody.appendChild(fragment);
        this.tbody.parentElement.scrollTop = scrollTop;
    }

    populateRow(row, item, index) {
        const cells = row.querySelectorAll('[data-field]');

        for (const cell of cells) {
            const field = cell.getAttribute('data-field');
            const value = this.resolveValue(item, field);
            const renderer = this.columnRenderers[field];

            if (renderer) {
                // Кастомный рендер
                const result = renderer.call(this.ctrl, value, item, index);
                this.applyCellContent(cell, result);
            } else {
                // Декларативное форматирование из атрибутов
                this.applyDeclarativeRender(cell, value, item);
            }
        }

        // Кастомные колонки без data-field (например _actions)
        const customCells = row.querySelectorAll('[data-render]');
        for (const cell of customCells) {
            const renderName = cell.getAttribute('data-render');
            const renderer = this.columnRenderers[renderName];
            if (renderer) {
                const result = renderer.render.call(this.ctrl, null, item, index);
                this.applyCellContent(cell, result);
            }
        }

        // Условные классы на строке
        if (row.hasAttribute('data-row-class')) {
            const fn = this.columnRenderers['_rowClass'];
            if (fn) {
                const cls = fn(item, index);
                if (cls) row.className = cls;
            }
        }
    }

    applyCellContent(cell, result) {
        if (result == null) return;

        if (result instanceof Node || result instanceof DocumentFragment) {
            cell.textContent = '';
            cell.appendChild(result);
        } else {
            cell.innerHTML = String(result);
        }
    }

    applyDeclarativeRender(cell, value, item) {
        // data-format
        const format = cell.getAttribute('data-format');
        if (format) {
            value = this.applyFormat(value, format);
        }

        cell.textContent = value ?? '';

        // data-class-map: {"active":"green","blocked":"red"}
        const classMap = cell.getAttribute('data-class-map');
        if (classMap) {
            try {
                const map = JSON.parse(classMap);
                const cls = map[value];
                if (cls) cell.className = cls;
            } catch (e) { }
        }

        // data-rule: {"lt":0,"class":"text-red"}
        const rule = cell.getAttribute('data-rule');
        if (rule) {
            try {
                const r = JSON.parse(rule);
                const numVal = Number(value);
                const match =
                    (r.lt != null && numVal < r.lt) ||
                    (r.gt != null && numVal > r.gt) ||
                    (r.eq != null && value == r.eq);
                if (match && r.class) cell.classList.add(...r.class.split(' '));
            } catch (e) { }
        }
    }

    applyFormat(value, format) {
        const [type, arg] = format.split(':');
        switch (type) {
            case 'date':
                return this.formatDate(value, arg);
            case 'number':
                return Number(value).toFixed(Number(arg) || 0);
            case 'boolean':
                return value ? '✓' : '—';
            default:
                return value;
        }
    }

    formatDate(value, pattern) {
        if (!value) return '';
        const d = new Date(value);
        if (!pattern) return d.toLocaleDateString('en');
        // Простой форматтер
        return pattern
            .replace('dd', String(d.getDate()).padStart(2, '0'))
            .replace('MM', String(d.getMonth() + 1).padStart(2, '0'))
            .replace('yyyy', d.getFullYear())
            .replace('HH', String(d.getHours()).padStart(2, '0'))
            .replace('mm', String(d.getMinutes()).padStart(2, '0'));
    }

    resolveValue(obj, path) {
        return path.split('.').reduce((o, k) => o?.[k], obj);
    }
}